
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/member/zendeskhelp/[link]",
      function () {
        return require("private-next-pages/mobiworkx/member/zendeskhelp/[link].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/member/zendeskhelp/[link]"])
      });
    }
  